import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';



export const benefitTableStyles = makeStyles((theme) => ({
    tableWrapper: {
        '&.left-aligned-cells': {
            '& .benefit-table-row-cell': {
                textAlign: 'left',
            },
        },

        '& .benefit-table': {
            '&-row': {
                margin: 0,
                padding: 0,
                borderBottom: `1px solid ${tcsmColors.greyFour}`,
                [theme.breakpoints.up('sm')]: {
                    display: 'table',
                    tableLayout: 'fixed',
                    width: '100%',
                    maxWidth: '100%',
                },
                '&-disabled': {
                    '& .benefit-table-row-cell': {
                        opacity: '0.6',
                        cursor: 'not-allowed',
                    },
                },
                '&-cell': {
                    [theme.breakpoints.up('sm')]: {
                        display: 'table-cell',
                        verticalAlign: 'top',
                        textAlign: 'center',
                    },
                    wordBreak: 'break-word',
                    padding: '1rem .5rem',
                    '& .MuiSelect-root': {
                        textAlign: 'left',
                    },
                    '&-name': {
                        [theme.breakpoints.up('sm')]: {
                            width: '35%',
                            textAlign: 'left',
                        },
                        [theme.breakpoints.up('lg')]: {
                            width: '25%',
                            textAlign: 'left',
                        },
                    },
                    '&-checkbox': {
                        [theme.breakpoints.up('sm')]: {
                            width: '5rem',
                        },
                       
                        [theme.breakpoints.down('sm')]: {
                            paddingBottom: '0',
                        },
                    },
               

                    '&-status': {
                        display: 'flex',
                        '&-icon': {
                            width: '1rem',
                            height: '1rem',
                            flex: '0 0 auto',
                            marginRight: theme.spacing(.5),
                            '&.warning': {
                                fill: tcsmColors.yellow,
                            },
                        },
                    },
                    '&.icon-row-title': {
                        [theme.breakpoints.up('sm')]: {
                            paddingLeft: theme.spacing(2.5),
                        },
                    },
                    '& .icon-button-cell': {
                        display: 'flex',
                        '& button': {
                            '& + button': {
                                marginLeft: theme.spacing(1.5),
                            },
                        },
                    },
                    '&-number-field': {
                        display: 'flex',
                        alignItems: 'center',
                        '& .green-check': {
                            fill: tcsmColors.green,
                            marginLeft: theme.spacing(.5),
                        },
                        '&-valid': {
                            '& .MuiInputBase-root': {
                                borderColor: tcsmColors.green,
                            },
                        },
                        '&-invalid': {
                            '& .MuiInputBase-root': {
                                borderColor: tcsmColors.red,
                            },
                        },
                        '& .MuiInputBase-root:after': {
                            [theme.breakpoints.down('md')]: {
                                marginRight: theme.spacing(.5),
                            },
                        },
                    },
                },
            },
            '&-content': {
                borderTop: `1px solid ${tcsmColors.greySeven}`,
                '& >.sort-table-row': {

                    '&:nth-child(even)': {
                        backgroundColor: tcsmColors.greySeven,
                    },
                },
                '& .table-pagination': {
                    padding: theme.spacing(1),
                    borderTop: `1px solid ${tcsmColors.greySeven}`,
                },
                '& .clergy-icon': {
                    fill: tcsmColors.blue,
                    width: '1rem',
                    height: '1rem',
                    flex: '0 0 auto',
                },
            },
            '&-header': {
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
                paddingRight: theme.spacing(2),
               
                textAlign: 'right',
                color: tcsmColors.darkBlue,
                [theme.breakpoints.up('md')]: {
                    width: '87%', /// (35% + (13 X 4))
                },
            },
            '&-helper': {
                '&-text': {
                    flex: '1 1 auto',
                    textAlign: 'right',
                    paddingRight: theme.spacing(2),
                    color: tcsmColors.darkBlue,
                    display: 'flex',
                    justifyContent: 'flex-end',
                },
                '&-row': {
                    borderBottom: `1px solid ${tcsmColors.greyFour}`,
                    '&-inner': {
                        display: 'flex',
                        alignItems: 'flex-start',
                        paddingTop: theme.spacing(1),
                        paddingBottom: theme.spacing(1),
                        [theme.breakpoints.up('md')]: {
                            width: '87%', /// (35% + (13 X 4))
                        },
                    },
                    
                },
            },
        },

    },



}));



